// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1pdc3","rootNoMargin":"styles_rootNoMargin__2Rv-H"};